import NewsDetails from "./NewsDetails";

export default NewsDetails;
